import { Collection } from 'modules/core/lib/mobx-rest'

import A3nomConfig from 'modules/payroll_integrations_a3nom/store/models/A3nomConfig'

class A3nomConfigs extends Collection<A3nomConfig> {
  get cacheKey(): string {
    return 'a3nomConfigs'
  }

  model() {
    return A3nomConfig
  }
}

const singleton: A3nomConfigs = new A3nomConfigs()

export default singleton
